import React from 'react';

import { useTranslation } from '@/i18n';
import { Button } from '@/ui/controls';
import { ConfirmationModal } from '@/ui/controls/ConfirmationModal.component';
import { Spacer } from '@/ui/spacing';
import { BodySmall } from '@/ui/typography';

interface BookingAmendmentModalProps {
  onRequestClose: () => void;
  isOpen: boolean;
  onContinueClick: () => void;
}

export const BookingAmendmentModal: React.FC<BookingAmendmentModalProps> = (
  props
) => {
  const { t } = useTranslation('bookingManagement');

  return (
    <ConfirmationModal
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
      title={t('amendment.confirmationModal.title')}
    >
      <BodySmall>{t('amendment.confirmationModal.body')}</BodySmall>
      <Spacer s="xl" />
      <Button onClick={props.onContinueClick} variant="secondary">
        {t('amendment.confirmationModal.continueButtonLabel')}
      </Button>
    </ConfirmationModal>
  );
};
